import { thunkActionLoading } from '@configs'
import { createSlice } from '@reduxjs/toolkit'
import { IFeatureDetail } from 'src/components/evolve-landing-page-management/feature/FeatureDetailModal'
import { ICartItem } from 'src/interfaces/cart-management'
import { getListCartAction } from '../actions/cart-management'
import { stat } from 'fs'

interface ICartManagement {
  carts: ICartItem[] | undefined
  selectedFeature: IFeatureDetail | undefined
  loadings: Record<string, boolean | undefined>
  totalCart: number
  currentPage: number
}

const initialState: ICartManagement = {
  carts: undefined,
  selectedFeature: undefined,
  loadings: {},
  totalCart: 0,
  currentPage: 1,
}

const cartManagement = createSlice({
  name: 'cartManagement',
  initialState,
  reducers: {
    clearSelectedFeature: (state) => {
      state.selectedFeature = undefined
    },
    setSelectedFeature: (state, action) => {
      state.selectedFeature = action.payload
    },
  },
  extraReducers: (builder) => {
    // list cart Actions
    builder.addCase(getListCartAction.pending, (state) => {
      state.loadings[thunkActionLoading.GET_LIST_LOADING] = true
    })
    builder.addCase(getListCartAction.rejected, (state) => {
      state.loadings[thunkActionLoading.GET_LIST_LOADING] = false
    })
    builder.addCase(getListCartAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.GET_LIST_LOADING] = false
      state.carts = action.payload.data.data.items
      state.totalCart = action.payload.data.data.total
      state.currentPage = action.payload.data.data.page
    })
  },
})

export const cartActions = {
  ...cartManagement.actions,
}

export default cartManagement.reducer
